// FILE: _chat.index.tsx
// Purpose: `/` — the home page.
// Layer: Route container
//
// This route used to redirect: it created (or reused) a draft thread in
// whatever project happened to be first and replaced the URL with it, so `/`
// was never a screen anyone saw. That left a user with no visible project
// staring at a blank page, and it created a draft thread per session as a side
// effect of merely signing in. Landing is now an explicit screen.

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { HomeView } from "../components/HomeView";
import { useFocusedProject } from "../focusMode";

function ChatIndexRouteView() {
  const navigate = useNavigate();
  const { focusedProject } = useFocusedProject();

  useEffect(() => {
    if (!focusedProject) return;
    void navigate({
      to: "/projects/$projectId",
      params: { projectId: focusedProject.id },
      replace: true,
    });
  }, [focusedProject, navigate]);

  return <HomeView />;
}

export const Route = createFileRoute("/_chat/")({
  component: ChatIndexRouteView,
});
